import VendorEditContainer from "./VendorEditContainer";
export default VendorEditContainer;
